import { useCallback } from 'react';
import { updateClipData } from '../clipUpdateDataUtils';
import { CLIP_UPDATE_TYPE } from '../clipUpdateDataUtils/constants';

export function useRemoveVideoSegment(clipId: string, segmentId: string) {
  return useCallback(() => {
    updateClipData({
      clipId,
      actionType: CLIP_UPDATE_TYPE.REMOVE_SEGMENT_TRACK,
      id: segmentId
    });
  }, [clipId, segmentId]);
}
